export default __webpack_public_path__ + "static/media/esvd-newlogo.e684550e.webp";